// extracted by mini-css-extract-plugin
export default {"loadFrameContainer":"LoadFrameButton_loadFrameContainer__4IfK-","selected":"LoadFrameButton_selected__1C7D4"};